module.exports = __webpack_public_path__ + "img/logo.775c6716.jpg";